// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs-wrapper {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--light-blue-color);
  height: 2.219rem;
  margin: 0 2rem;
}

.tabs-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
}
.tabs-container .tab {
  outline: none;
  border: none;
  font-size: 1.1rem;
  cursor: pointer;
  list-style: none;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.6rem;
  border-radius: 0.5rem 0 0 0;
  font-size: var(--font-size-12);
  font-style: var(--font-style-normal);
  font-weight: var(--font-weight-500);
  -webkit-user-select: none;
          user-select: none;
  z-index: 2;
  transition: all ease 0.5s;
  color: var(--black-color);
}
.tabs-container .tab-active {
  color: var(--pure-white-color);
  transition: all ease 0.5s;
}
.tabs-container .tab-disabled {
  pointer-events: none;
  color: gray;
}
.tabs-container .indicator {
  position: absolute;
  height: 2.219rem;
  left: 0;
  width: 78px;
  z-index: 1;
  transition: all ease 0.5s;
}
.tabs-container .indicator .indicator-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--primary-color);
  border-radius: 0.5rem 0 0 0;
}
.tabs-container .indicator .svg-container {
  position: absolute;
  right: -37px;
}`, "",{"version":3,"sources":["webpack://./src/component/common/tabs/Tabs.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,gDAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AACF;AACE;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,8BAAA;EACA,oCAAA;EACA,mCAAA;EACA,yBAAA;UAAA,iBAAA;EACA,UAAA;EACA,yBAAA;EACA,yBAAA;AACJ;AACI;EACE,8BAAA;EACA,yBAAA;AACN;AAEI;EACE,oBAAA;EACA,WAAA;AAAN;AAIE;EACE,kBAAA;EACA,gBAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;AAFJ;AAII;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;AAFR;AAII;EACI,kBAAA;EACA,YAAA;AAFR","sourcesContent":[".tabs-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  border-bottom: 1px solid var(--light-blue-color);\n  height: 2.219rem;\n  margin: 0 2rem;\n}\n\n.tabs-container {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n  flex-wrap: wrap;\n\n  .tab {\n    outline: none;\n    border: none;\n    font-size: 1.1rem;\n    cursor: pointer;\n    list-style: none;\n    height: 100%;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-left: 0.6rem;\n    border-radius: 0.5rem 0 0 0;\n    font-size: var(--font-size-12);\n    font-style: var(--font-style-normal);\n    font-weight: var(--font-weight-500);\n    user-select: none;\n    z-index: 2;\n    transition: all ease 0.5s;\n    color: var(--black-color);\n  \n    &-active{\n      color: var(--pure-white-color);\n      transition: all ease 0.5s;\n    }\n  \n    &-disabled {\n      pointer-events: none;\n      color: gray;\n    }\n  }\n\n  .indicator{\n    position: absolute;\n    height: 2.219rem;\n    left: 0;\n    width: 78px;\n    z-index: 1;\n    transition: all ease 0.5s;\n\n    .indicator-container{\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: var(--primary-color);\n        border-radius: 0.5rem 0 0 0;\n    }\n    .svg-container{\n        position: absolute;\n        right: -37px;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
